module.exports = __webpack_public_path__ + "img/M9.97012021.png";